import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: inline-flex;
  flex-direction: column;
  font-family: 'Noto Sans', sans-serif;
  min-width: 400px;
  min-height: 250px;
`;
Container.displayName = 'Container';

export const Time = styled.div`
  align-items: center;
  color: #ffffff;
  display: flex;
  font-size: 80px;
  font-style: normal;
  font-weight: bold;
  justify-content: center;
  letter-spacing: 2px;
  line-height: 64px;
  margin-top: 8px;
  min-width: 305px;
  position: relative;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #ffffff;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 40px;
  margin-bottom: 12px;
  position: relative;
  text-align: center;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
